import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const Beneficiaries = () => {
  const {
    register,
    watch
  } = useFormContext();
  const [specificGifts, setSpecificGifts] = useState([{
    id: 1,
    item: '',
    recipient: ''
  }]);
  const addGift = () => {
    const newId = specificGifts.length > 0 ? Math.max(...specificGifts.map(g => g.id)) + 1 : 1;
    setSpecificGifts([...specificGifts, {
      id: newId,
      item: '',
      recipient: ''
    }]);
  };
  const removeGift = (id: number) => {
    setSpecificGifts(specificGifts.filter(gift => gift.id !== id));
  };
  return <div className="space-y-8" data-id="element-451" data-mp="3d9etoixehk8r">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-452" data-mp="3d8d7pjeujdc9">
        <p className="text-slate-700" data-id="element-453" data-mp="4tldk56zeas8">
          Please provide information about how you would like your assets to be
          distributed after your death.
        </p>
      </div>

      {/* Specific Gifts/Bequests */}
      <div className="space-y-4" data-id="element-454" data-mp="10di8a8ezj6p5">
        <div className="flex justify-between items-center" data-id="element-455" data-mp="vhjeg5aw0whc">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-456" data-mp="vex6w5nzygz4">
            Specific Gifts or Bequests (Optional)
          </h3>
          <button type="button" onClick={addGift} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-457" data-mp="15e5y4qrh9hhs">
            <PlusIcon size={16} className="mr-1" data-id="element-458" data-mp="1e7rcwa3n6yr7" />
            Add Gift
          </button>
        </div>
        <p className="text-sm text-slate-600 mb-4" data-id="element-459" data-mp="1t51xc8y9jez2">
          List any specific items or amounts you wish to leave to particular
          individuals.
        </p>

        {specificGifts.map((gift, index) => <div key={gift.id} className="p-4 bg-slate-50 rounded-md" data-id="element-460" data-mp="3uwwu7ifv1ex8" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-461" data-mp="3px22xds6anbn">
              <h4 className="font-medium" data-id="element-462" data-mp="3pyvdh45wprox">Gift {index + 1}</h4>
              {specificGifts.length > 1 && <button type="button" onClick={() => removeGift(gift.id)} className="text-red-500 hover:text-red-700" data-id="element-463" data-mp="jhwjwsmip8il">
                  <TrashIcon size={16} data-id="element-464" data-mp="sib6dvb7wtno" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-465" data-mp="xd8dgwoxssxx">
              <div data-id="element-466" data-mp="12dmngka3mcyl">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-467" data-mp="12e5uv724hiyd">
                  Item or Amount
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Jewelry collection, $10,000" {...register(`specificGifts.${index}.item`)} data-id="element-468" data-mp="1b6pti7ieznj7" />
              </div>
              <div data-id="element-469" data-mp="1q4i90znyobxe">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-470" data-mp="1q1w314gpy4ha">
                  Recipient
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter recipient's name" {...register(`specificGifts.${index}.recipient`)} data-id="element-471" data-mp="35my4exkz9si9" />
              </div>
            </div>
          </div>)}
      </div>

      {/* Primary Beneficiaries */}
      <div className="space-y-4" data-id="element-472" data-mp="3oeh3wufsmofj">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-473" data-mp="3ofiqnw668zd3">
          Primary Beneficiaries
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-474" data-mp="3enw9zkb2e82y">
          Who should receive the residue of your estate (everything not
          specifically given away)?
        </p>

        <div data-id="element-475" data-mp="fzgxnqjmqkld">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-476" data-mp="b6w2olozm1g9">
            How would you like to distribute your estate?
          </label>
          <div className="space-y-3" data-id="element-477" data-mp="3rthadjkgyj3y">
            <label className="flex items-start" data-id="element-478" data-mp="3rwn0910x9p0q">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="spouse" {...register('beneficiaries.distribution')} data-id="element-479" data-mp="p0o0k050e89" />
              <span className="ml-2 block" data-id="element-480" data-mp="3mvfrozqyglt0">
                <span className="font-medium" data-id="element-481" data-mp="efnr0ocxkqa5">All to spouse</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-482" data-mp="ehgww1fpz6h3">
                  Your entire estate goes to your spouse.
                </span>
              </span>
            </label>

            <label className="flex items-start" data-id="element-483" data-mp="4pawq4fbdiqt">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="spouseThenChildren" {...register('beneficiaries.distribution')} data-id="element-484" data-mp="9o5klks51xhs" />
              <span className="ml-2 block" data-id="element-485" data-mp="126ja8x3bmd5s">
                <span className="font-medium" data-id="element-486" data-mp="2mv3wtv4mjh7l">
                  All to spouse, then to children equally if spouse predeceases
                </span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-487" data-mp="2hvr9zadr6a50">
                  Your entire estate goes to your spouse, but if your spouse
                  dies before you, it's divided equally among your children. If
                  you have a child who also predeceases but leaves children of
                  his or her own, then that deceased child's share would be
                  divided amongst his or her children if they have any.
                </span>
              </span>
            </label>

            <label className="flex items-start" data-id="element-488" data-mp="2cv38tvvt8cx2">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="children" {...register('beneficiaries.distribution')} data-id="element-489" data-mp="28vcmq5h8akyv" />
              <span className="ml-2 block" data-id="element-490" data-mp="3ka807o452gdu">
                <span className="font-medium" data-id="element-491" data-mp="2gzu633g5iyv2">All to children equally</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-492" data-mp="2h1y9lka51vut">
                  Your estate is divided equally among your children.
                </span>
              </span>
            </label>

            <label className="flex items-start" data-id="element-493" data-mp="2qvxakfyh79l6">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="custom" {...register('beneficiaries.distribution')} data-id="element-494" data-mp="2uzwiia5ox02x" />
              <span className="ml-2 block" data-id="element-495" data-mp="238ys5cqsprkm">
                <span className="font-medium" data-id="element-496" data-mp="27aamtwoj12zo">Custom distribution</span>
                <span className="text-sm text-slate-500 block mt-0.5" data-id="element-497" data-mp="277xx2xcj1oc2">
                  Specify your own distribution plan.
                </span>
              </span>
            </label>
          </div>
        </div>

        {watch('beneficiaries.distribution') === 'custom' && <div className="mt-4" data-id="element-498" data-mp="1jiwv9sy79bfr">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-499" data-mp="1c0ynptzkwaf6">
              Custom Distribution Plan
            </label>
            <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Describe how you want your estate distributed (e.g., 50% to spouse, 25% to each child)" {...register('beneficiaries.customPlan')} data-id="element-500" data-mp="171m2fdocvbep" />
          </div>}
      </div>

      {/* Alternate Beneficiaries */}
      <div className="space-y-4" data-id="element-501" data-mp="o9taznoxpy93">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-502" data-mp="jc9j3kzbdmyo">
          Alternate Beneficiaries
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-503" data-mp="fbhc6ydwzu5k">
          Who should receive your estate if none of your primary beneficiaries
          survive you?
        </p>

        <div data-id="element-504" data-mp="5ci8lu80aopf">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-505" data-mp="5bysmj1x2ae1">
            Alternate Beneficiaries
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter names and relationships of alternate beneficiaries" {...register('beneficiaries.alternates')} data-id="element-506" data-mp="1ta9f0pd4rf4d" />
          <p className="text-sm text-slate-500 mt-1" data-id="element-507" data-mp="1p61n6jbdlj1x">
            Examples: siblings, nieces/nephews, parents, charities
          </p>
        </div>
      </div>

      {/* Age of Inheritance */}
      <div className="space-y-4" data-id="element-508" data-mp="1fa6vkyp6cdn0">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-509" data-mp="1fb9pzglpgy7o">
          Age of Inheritance
        </h3>

        <div data-id="element-510" data-mp="15j3uvy05q0o9">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-511" data-mp="15kndhv9acnt7">
            At what age should beneficiaries under 18 receive their inheritance?
          </label>
          <div className="flex items-center space-x-4" data-id="element-512" data-mp="winx9563hnrb">
            <label className="inline-flex items-center" data-id="element-513" data-mp="wie1t22a6oe8">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="18" {...register('beneficiaries.ageOfInheritance')} data-id="element-514" data-mp="cwm49zqgv59d" />
              <span className="ml-2" data-id="element-515" data-mp="mwcu3o430w34">18</span>
            </label>
            <label className="inline-flex items-center" data-id="element-516" data-mp="hwi6btflsmma">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="21" {...register('beneficiaries.ageOfInheritance')} data-id="element-517" data-mp="huxa7zdn4vmb" />
              <span className="ml-2" data-id="element-518" data-mp="qv2iscukm022">21</span>
            </label>
            <label className="inline-flex items-center" data-id="element-519" data-mp="15khxuvkqoh1x">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="25" {...register('beneficiaries.ageOfInheritance')} data-id="element-520" data-mp="10mzy9vsm3e6l" />
              <span className="ml-2" data-id="element-521" data-mp="1alp4grb5ba70">25</span>
            </label>
            <label className="inline-flex items-center" data-id="element-522" data-mp="ykskz7mcevba">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="custom" {...register('beneficiaries.ageOfInheritance')} data-id="element-523" data-mp="ymdgazgheia7" />
              <span className="ml-2" data-id="element-524" data-mp="oswmvwk9b572">Other</span>
            </label>
          </div>

          {watch('beneficiaries.ageOfInheritance') === 'custom' && <div className="mt-3" data-id="element-525" data-mp="1hjwpq46uq2x5">
              <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter age" {...register('beneficiaries.customAge')} data-id="element-526" data-mp="1hive9ylxbeew" />
            </div>}
          <p className="text-sm text-slate-500 mt-2" data-id="element-527" data-mp="3sbpwjy9wz9vy">
            Until this age is reached, the inheritance will be held in trust and
            managed by trustees.
          </p>
        </div>
      </div>

      {/* Guardians/Custodians */}
      <div className="space-y-4" data-id="element-528" data-mp="23t3htxuipz40">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-529" data-mp="23pz7eiqgm74w">
          Guardians for Minor Children
        </h3>

        <div data-id="element-530" data-mp="2cs8fl1y99of4">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-531" data-mp="2crpailtpeuii">
            Guardian's Name
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter guardian's name" {...register('guardians.name')} data-id="element-532" data-mp="2hk8m5d8tzfko" />
        </div>

        <div data-id="element-533" data-mp="2vkb1arpr7uw8">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-534" data-mp="2vkjcmf68as5b">
            Alternate Guardian's Name
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate guardian's name" {...register('guardians.alternate')} data-id="element-535" data-mp="30g8i0z4xj39j" />
        </div>

        <div data-id="element-536" data-mp="29hbnzeac189o">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-537" data-mp="24g4f1bwge31f">
            Monthly Allowance for Guardians (Optional)
          </label>
          <div className="relative" data-id="element-538" data-mp="2igyozyz5gc27">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-539" data-mp="2idsziimlz85y">
              <span className="text-slate-500" data-id="element-540" data-mp="2dix6pg9jsgrs">$</span>
            </div>
            <input type="number" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Amount" {...register('guardians.monthlyAllowance')} data-id="element-541" data-mp="2scsa46qxpdvl" />
          </div>
        </div>
      </div>
    </div>;
};
export default Beneficiaries;